<div class="parametres-container">
    <app-ongletlayout
        storageId="parametres"
        [ongletLinks]="tableLinkForParameters"
        [title]="'Paramètres'"
    >
        <div>
            <router-outlet></router-outlet>
        </div>
    </app-ongletlayout>
</div>